import '../login.scss';
import {observer} from "mobx-react";
import {
    EmailVerificationStep,
    SignupPersonalDetailsStep,
    SignupFlow
} from "../SharedSteps";
import frontlineLogo from "../../../assets/img/frontline-logo-blue.svg";
import rotaxLogo from "../../../assets/img/rotax-logo.png";
import rotaxEng1 from "../../../assets/img/rotax-914-termin_1.png";
import rotaxEng2 from "../../../assets/img/rotax-912-termin_1.png";
import rotaxEng3 from "../../../assets/img/rotax-912UL-termin_1.png";
import rotaxEng4 from "../../../assets/img/rotax-915iS_V2-T1_915.png";
import rotaxEng5 from "../../../assets/img/rotax-912iS.png";
import React, {useEffect} from "react";
import sharedUtils, {CONVENTION_LOGIN_DOMAIN} from "../../../serverClientShared/sharedUtils";
import Cookies from "js-cookie";
import Settings from "../../../settings.json";
import {useStores} from "../../../Hooks";
import ConditionalComponent from "../../Shared/ConditionalComponent";
import ConventionLinks from "./ConventionLinks";
import {ConventionLandingStep} from "./ConventionLandingStep";


const steps = [
    {
        label: "mainPage",
        component: ConventionLandingStep
    },
    {
        label: "userDetails",
        component: SignupPersonalDetailsStep
    },
    {
        label: "emailVerification",
        component: EmailVerificationStep
    },
];

const ConventionSignup = observer(() => {
    const {generalStore} = useStores();
    const {workspace} = generalStore;

    useEffect(() => {
        generalStore.showHelpDesk = false;
        const tokenFromCookies = Cookies.get(Settings.tokenCookieName);
        if (workspace !== CONVENTION_LOGIN_DOMAIN && workspace !== Settings.conventionWorkspace) {
            let {host, protocol} = window.location;
            if (!workspace) {
                host = `${sharedUtils.LOGIN_DOMAIN}.${host}`;
            }
            window.location.href = `${protocol}//${host.replace(`${workspace}.`, `${sharedUtils.LOGIN_DOMAIN}.`)}/login`;
        } else if (!!tokenFromCookies) {
            generalStore.isLoaderOpen = true;
            try {
                generalStore.getSelfUserDetails().then((userDetails) => {
                    if (!userDetails) {
                        throw new Error("token no longer valid")
                    } else {
                        generalStore.setLoginState();
                        generalStore.isLoaderOpen = false;
                    }
                })
            } catch (e) {
                console.error(e);
                Cookies.remove(Settings.tokenCookieName);
                generalStore.userDetails = {};
                generalStore.isLoaderOpen = false;
            }
        } else {
            Cookies.remove(Settings.tokenCookieName);
            generalStore.userDetails = {};
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='on-boarding-container convention' key={generalStore.loggedIn}>
            <div className="logo-container">
                <img src={rotaxLogo} alt='' className='logo'/>
                <img src={frontlineLogo} alt='' className='logo'/>
            </div>
            <div className='rotax-engines'>
                <div className='engines-left'>
                    <img src={rotaxEng1} alt='' className='rotax-engine'/>
                    <img src={rotaxEng2} alt='' className='rotax-engine'/>
                </div>
                <div className='engines-right'>
                    <img src={rotaxEng3} alt='' className='rotax-engine'/>
                    <img src={rotaxEng4} alt='' className='rotax-engine'/>
                    <img src={rotaxEng5} alt='' className='rotax-engine'/>
                </div>
            </div>
            <ConditionalComponent if={!!generalStore.loggedIn}>
                <ConventionLinks/>
            </ConditionalComponent>
            <ConditionalComponent if={!generalStore.loggedIn}>
                <SignupFlow steps={steps} isConvention={true} withoutStepper={true}/>
            </ConditionalComponent>
        </div>
    );
});

export default ConventionSignup;
